import { SVGProps, Ref, forwardRef } from 'react';

export const DnrBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.404 1.5v.008C20.624 1.34 22.148 6.21 22.148 6.21c1.207 1.64 1.063 8.599 0 10.194 0 0-2.293 5.712-12.744 5.747v.015h-5.49v-17.6L1 3.433V1.5zm0 17.394V4.732c6.13-.58 7.672 3.121 7.672 3.121.967 2.536.967 5.34 0 7.876 0 0-.85 3.94-7.672 3.165"
                fill="#2B96CF"
            />
        </g>
    </svg>
));
DnrBrandSize24Glyph.displayName = 'DnrBrandSize24Glyph';
